// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"62016a6f","498":"ba3c2c89","703":"c2979c64","787":"afe91509"}[chunkId] + ".chunk.js";
};